export const menuItems = [
  { name: 'Об олимпиаде', path: 'about-olymp' },
  { name: 'Объявления', path: 'announcements' },
  { name: 'Материалы для подготовки', path: 'prep-materials' },
  { name: 'Архив', path: 'archive' },
  { name: 'Результаты', path: 'results' },
  { name: 'Жюри', path: 'jury' },
];
